import { render, staticRenderFns } from "./dialog_addShop.vue?vue&type=template&id=37927ecc&scoped=true&"
import script from "./dialog_addShop.vue?vue&type=script&lang=js&"
export * from "./dialog_addShop.vue?vue&type=script&lang=js&"
import style0 from "./dialog_addShop.vue?vue&type=style&index=0&id=37927ecc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37927ecc",
  null
  
)

export default component.exports